module.exports = __webpack_public_path__ + "static/media/fail.a737775c.png";